/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum SendStatus {
  Unknown = 0,
  Sent = 1,
  SentAndGiveBackCredit = 2,
  ErrorInSending = 3,
  ErrorInGetItc = 4,
  BlackList = 5,
  Stored = 6,
  NotSend = 7,
  Filtered = 8,
  WhiteMessageLimit = 9,
  Deleted = 10,
  SmsLinkNotAllow = 11
}
